import { render, staticRenderFns } from "./componentCollapseToAdult.vue?vue&type=template&id=01382a65&scoped=true"
import script from "./componentCollapseToAdult.vue?vue&type=script&lang=js"
export * from "./componentCollapseToAdult.vue?vue&type=script&lang=js"
import style0 from "./componentCollapseToAdult.vue?vue&type=style&index=0&id=01382a65&lang=scss"
import style1 from "./componentCollapseToAdult.vue?vue&type=style&index=1&id=01382a65&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01382a65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01382a65')) {
      api.createRecord('01382a65', component.options)
    } else {
      api.reload('01382a65', component.options)
    }
    module.hot.accept("./componentCollapseToAdult.vue?vue&type=template&id=01382a65&scoped=true", function () {
      api.rerender('01382a65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentCollapseToAdult.vue"
export default component.exports